import { render, staticRenderFns } from "./listarVendas.vue?vue&type=template&id=1edc3f15&scoped=true&"
import script from "./listarVendas.vue?vue&type=script&lang=js&"
export * from "./listarVendas.vue?vue&type=script&lang=js&"
import style0 from "./listarVendas.vue?vue&type=style&index=0&id=1edc3f15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc3f15",
  null
  
)

export default component.exports